module.exports = __webpack_public_path__ + "img/photo1.7cb393e9.jpg";